import React from 'react';
import OdfjellInputComponent, { InputChangeData } from 'src/components/common/odfjell-input-component/OdfjellInputComponent';
import { EnginesDataVM } from '../EnginesSection';
import { FuelType } from 'src/types/ViewModel/Bunkering/FuelType';
import { ConsumptionByUsageWrapper } from '../EnginesSection.style';
import { BoilersUsageTypeEnum } from 'src/types/ViewModel/AolEnums';

interface Props {
    canUseHfo: boolean;
    isReadOnly: boolean;
    enginesDataVM: EnginesDataVM;
    onInputChange: (inputData: InputChangeData) => void;
    name: string;
    aolVersion?: number | undefined;
    fuelTypes?: FuelType[] | undefined;
    consumptionType?: BoilersUsageTypeEnum | undefined;
}

const ConsumptionByUsage: React.FC<Props> = ({
    canUseHfo,
    isReadOnly,
    enginesDataVM,
    onInputChange,
    name,
    aolVersion,
    fuelTypes,
    consumptionType,
}) => {
    if (aolVersion && aolVersion >= 5) {
        return (
            <ConsumptionByUsageWrapper gridCols={fuelTypes?.length}>
                {fuelTypes?.map((fuelType) => (
                    <OdfjellInputComponent
                        key={`${name}${fuelType}`}
                        isReadOnly={isReadOnly}
                        type={'number'}
                        value={
                            enginesDataVM.boilerConsumptionV5?.find((x) => x.BoilersUsageType === consumptionType && x.FuelTypeId === fuelType)
                                ?.QuantityMt
                        }
                        dataObject={enginesDataVM}
                        extraArgs={{ fuelType, consumptionType }}
                        onChange={onInputChange}
                        name={'consumptionByUsageV5'}
                        min={0}
                        max={50}
                        unit={'MT'}
                    />
                ))}
            </ConsumptionByUsageWrapper>
        );
    } else
        return (
            <ConsumptionByUsageWrapper>
                {canUseHfo && (
                    <OdfjellInputComponent
                        isReadOnly={isReadOnly}
                        type={'number'}
                        value={enginesDataVM['boilersConsumptionFor' + name]}
                        dataObject={enginesDataVM}
                        onChange={onInputChange}
                        name={'boilersConsumptionFor' + name}
                        min={0}
                        max={50}
                        unit={'MT'}
                    />
                )}
                <OdfjellInputComponent
                    isReadOnly={isReadOnly}
                    type={'number'}
                    value={enginesDataVM['boilersConsumptionFor' + name + 'Mgo']}
                    dataObject={enginesDataVM}
                    onChange={onInputChange}
                    name={'boilersConsumptionFor' + name + 'Mgo'}
                    min={0}
                    max={50}
                    unit={'MT'}
                />
            </ConsumptionByUsageWrapper>
        );
};

export default ConsumptionByUsage;
